import { createAction } from 'actions/utils';
import { GET_NAVBAR_OPTIONS, SET_PAGE_TITLE, SET_WITH_TABS } from 'constants/ActionTypes';
import { t } from 'utils/getLiteral';
import { showIntegrations } from 'utils/permissions';

export function getNavbarOptions(permissions, productCode) {
    return (dispatch, getState) => {
        const { authentication } = getState();
        const { impl = -1 } = authentication;
        const {
            users,
            valueList,
            widgetsSDK,
            formsSDK,
            extraFields,
            sandbox,
            literals,
            customEvents,
            api,
            importExport,
            parameters,
            permissions: roles,
            cron,
            fieldsValidations,
        } = permissions;

        const shouldShowIntegrations = showIntegrations(productCode);

        let options = [
            {
                type: 'link',
                section: 'workspace',
                link: '#/app/workspace',
                name: t('cfm_title_workspace'),
                icon: 'workspace',
            },
            {
                type: 'divider',
            },
        ];

        if (users?.rootUsers) {
            options.push({
                type: 'link',
                section: 'users',
                link: '#/app/users',
                name: t('cfm_title_users'),
                icon: 'users',
            });
            if (!roles?.rootPermissions)
                options.push({
                    type: 'divider',
                });
        }

        if (roles?.rootPermissions)
            options.push(
                {
                    type: 'link',
                    section: 'permissions',
                    link: '#/app/permissions',
                    name: t('cfm_label_permissions'),
                    icon: 'roles',
                },
                {
                    type: 'divider',
                },
            );

        if (extraFields?.rootExtraFields) {
            options.push({
                type: 'link',
                section: 'fields',
                link: '#/app/fields',
                name: t('cfm_title_fields'),
                icon: 'fields',
            });
            if (!valueList?.rootValueList && !fieldsValidations?.rootFieldsValidations)
                options.push({
                    type: 'divider',
                });
        }

        if (valueList?.rootValueList) {
            options.push({
                type: 'link',
                section: 'valueLists',
                link: '#/app/value-lists',
                name: t('cfm_title_value_list'),
                icon: 'list',
            });
            if (!fieldsValidations?.rootFieldsValidations)
                options.push({
                    type: 'divider',
                });
        }

        if (fieldsValidations?.rootFieldsValidations) {
            options.push(
                {
                    type: 'link',
                    section: 'validations',
                    link: '#/app/validations',
                    name: t('cfm_label_validations'),
                    icon: 'fieldsValidations',
                },
                { type: 'divider' },
            );
        }

        if (parameters?.rootParameters) {
            options.push({
                type: 'link',
                section: 'parameters',
                link: '#/app/parameters',
                name: t('cfm_title_parameters'),
                icon: 'parameters',
            });
            if (!widgetsSDK?.rootWidgetsSDK)
                options.push({
                    type: 'divider',
                });
        }

        if (widgetsSDK?.rootWidgetsSDK)
            options.push(
                {
                    type: 'link',
                    section: 'widgets',
                    link: '#/app/widgets',
                    name: t('cfm_title_widgets'),
                    icon: 'widgets',
                },
                {
                    type: 'divider',
                },
            );

        if (importExport?.rootImportExport) {
            options.push({
                type: 'link',
                section: 'imports',
                link: '#/app/imports',
                name: t('cfm_title_imports'),
                icon: 'importsAlt',
            });
            if (!literals?.rootLiterals && !api?.rootAPI)
                options.push({
                    type: 'divider',
                });
        }

        if (literals?.rootLiterals) {
            options.push(
                {
                    type: 'link',
                    section: 'literals',
                    link: '#/app/literals',
                    name: t('cfm_title_literals'),
                    icon: 'literals',
                },
                { type: 'divider' },
            );
        }

        if (customEvents?.rootCustomEvents) {
            options.push({
                type: 'link',
                section: 'customfunctions',
                link: '#/app/customfunc',
                name: t('cfm_title_custom_functions'),
                icon: 'functions',
            });
            if (!cron?.rootCron && !formsSDK?.rootFormsSDK && sandbox?.rootSandbox)
                options.push({
                    type: 'divider',
                });
        }

        if (cron?.rootCron) {
            options.push({
                type: 'link',
                section: 'crons',
                link: '#/app/crons',
                name: t('cfm_title_cron_management'),
                icon: 'crons',
            });
            if (
                !formsSDK?.rootFormsSDK &&
                process.env.NODE_ENV !== 'development' &&
                impl !== 59340 &&
                sandbox?.rootSandbox
            )
                options.push({
                    type: 'divider',
                });
        }

        if (formsSDK?.rootFormsSDK) {
            options.push({
                type: 'link',
                section: 'forms',
                link: '#/app/forms',
                name: t('cfm_title_forms'),
                icon: 'forms',
            });
            if (sandbox?.rootSandbox || sandbox?.rootAPI)
                options.push({
                    type: 'divider',
                });
        }

        if (api?.rootAPI)
            options.push({
                type: 'link',
                section: 'apikeys',
                link: '#/app/apikeys',
                name: t('cfm_title_apikey'),
                icon: 'credentials',
            });

        if (sandbox?.rootSandbox)
            options.push({
                type: 'link',
                section: 'sandbox',
                link: '#/app/sandbox',
                name: t('cfm_title_sandbox'),
                icon: 'sandbox',
            });

        if (shouldShowIntegrations) {
            options.push({
                type: 'link',
                section: 'integrations',
                link: '#/app/integrations',
                name: t('cfm_title_integrations'),
                icon: 'integrations',
            });
        }

        dispatch(createAction(GET_NAVBAR_OPTIONS, options));
    };
}

export const setHeaderProps =
    ({ title = '', withTabs = false }) =>
    (dispatch) => {
        dispatch(createAction(SET_PAGE_TITLE, title));
        dispatch(createAction(SET_WITH_TABS, withTabs));
    };
